/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const bottomWallItemWithDefaultCountertopComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'countertop', true).withAlias('BottomWallItemWithDefaultCountertop').withFilter(()=>({
            navigationStates: [
                'Room',
                'RoomContent',
                'Recipes'
            ]
        })).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'COUNTERTOP',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'countertop', true).withAlias('BottomWallItemWithDefaultCountertop').attach(memoEval((self)=>[
            self.$countertopOffsetX,
            self.$countertopWidth,
            self.$countertopWidthScaleZero,
            self.$countertopWidthScaleOne,
            self.$countertopDepth,
            self.$countertopDepthScaleZero,
            self.$countertopDepthScaleOne
        ], ($countertopOffsetX, $countertopWidth, $countertopWidthScaleZero, $countertopWidthScaleOne, $countertopDepth, $countertopDepthScaleZero, $countertopDepthScaleOne)=>({
            offsetX: $countertopOffsetX,
            morphTargetInfluences: {
                Width: {
                    value: $countertopWidth,
                    scaleZero: $countertopWidthScaleZero,
                    scaleOne: $countertopWidthScaleOne
                },
                Depth: {
                    value: $countertopDepth,
                    scaleZero: $countertopDepthScaleZero,
                    scaleOne: $countertopDepthScaleOne
                }
            }
        })))
];

//# sourceMappingURL=bottom-wall-item-with-default-countertop.js.map